'use strict';
import './structure/adjustVh';
import './structure/adjustViewport';

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);
// import animetejs
import anime from 'animejs';

document.addEventListener('DOMContentLoaded', () => {
  /*
    Swiper
    スライドのイベント Swiperを使用しています。
  */
  if (document.querySelector('.js_scoutSwiper')) {
    const swiper = new Swiper('.js_scoutSwiper', {
      autoplay: {
        delay: 5000,
      },
      modules: [Navigation],
      loop: true,
      slidesPerView: 4.5,
      spaceBetween: 10,
      navigation: {
        nextEl: '.m_cardScoutSlideNav.Right',
        prevEl: '.m_cardScoutSlideNav.Left',
      },
    });
  }
  if (document.querySelector('.js_topCampaign')) {
    const topSwiper = new Swiper('.js_topCampaign', {
      autoplay: {
        delay: 5000,
      },
      modules: [Pagination],
      loop: true,
      slidesPerView: 1.5,
      spaceBetween: 10,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }
  // End Swiper

  /*
    CardFLip
    class(CSSアニメーション)の付与を行っています
  */
  if (document.querySelector('.js-flipCardBox')) {
    // Flip
    const flipBox = document.querySelector('.js-flipCardBox');
    const flipCards = document.querySelectorAll('.js-flipCard');
    const flipBtn = document.querySelector('.js-flipCardButton');
    const flipEvent = () => {
      flipBox.classList.toggle('Flip');
    };
    for (let i = 0; i < flipCards.length; i++) {
      flipCards[i].addEventListener('click', (e) => {
        flipEvent();
      });
    }
    flipBtn.addEventListener('click', () => {
      flipEvent();
    });
  }
  // End CardFLip

  /*
    CardSwipe
    Home画面のカードスワイプ
  */
  if (document.querySelector('.js_HomeCard')) {
    let startX = null;
    let endX = null;
    const homeCards = document.querySelectorAll('.js_HomeCard');
    const homeCardsLeng = homeCards.length;
    const homeCardsLengMax = Number(homeCardsLeng - 1);
    const homeCardsBox = document.getElementById('HomeCards');

    const LSideDirection = () => {
      for (let i = 1; i < homeCards.length; i++) {
        const One = document.querySelector('.js_HomeCard' + i);
        One.classList.remove('js_HomeCard' + i);
        let Num = Number(i - 1);
        if (Num === 0) {
          Num = '00';
        }
        One.classList.add('js_HomeCard' + Num);
      }
      const zero = document.querySelector('.js_HomeCard0');
      zero.classList.remove('js_HomeCard0');
      zero.classList.add('js_HomeCard' + Number(homeCardsLeng - 1));
      const zeroStash = document.querySelector('.js_HomeCard00');
      zeroStash.classList.remove('js_HomeCard00');
      zeroStash.classList.add('js_HomeCard0');
    };

    const RSideDirection = () => {
      for (let i = homeCardsLengMax; i >= 0; i--) {
        const One = document.querySelector('.js_HomeCard' + i);
        One.classList.remove('js_HomeCard' + i);
        let Num = Number(i + 1);
        if (Num > homeCardsLengMax) {
          Num = '00';
        }
        One.classList.add('js_HomeCard' + Num);
      }
      const zeroStash = document.querySelector('.js_HomeCard00');
      zeroStash.classList.remove('js_HomeCard00');
      zeroStash.classList.add('js_HomeCard0');
    };

    const logSwipeStart = (event) => {
      event.preventDefault();
      startX = event.touches[0].pageX;
    };

    const logSwipe = (event) => {
      event.preventDefault();
      endX = event.touches[0].pageX;
    };

    const logSwipeEnd = (event) => {
      event.preventDefault();
      if (0 < endX - startX) {
        RSideDirection();
      } else {
        LSideDirection();
      }
    };
    homeCardsBox.addEventListener('touchmove', logSwipe);
    homeCardsBox.addEventListener('touchstart', logSwipeStart);
    homeCardsBox.addEventListener('touchend', logSwipeEnd);
    // End CardSwipe
  }

  if (document.querySelector('.p_DirectScenes')) {
    const next_url = document.getElementById('NextUrl');
    start_gacha_animation(next_url.value);
  }

});

function start_gacha_animation(next_url) {
  const Scene = document.querySelector('.p_DirectScenes');
  const Scene1 = document.querySelector('.p_DirectScene1');
  const Bg = document.querySelector('.p_DirectScene1Bg');
  const Logo = document.querySelector('.p_DirectLogo');
  // const Scene2 = document.querySelector('.p_DirectScene2');
  const Scene3 = document.querySelector('.p_DirectScene3');
  const Scene4 = document.querySelector('.p_DirectScene4');
  const Scene3Cards = document.querySelectorAll('.p_DirectScene3Card');
  const Scene4Cards = document.querySelectorAll('.p_DirectScene4CardSplit');
  const Scene3Roll = document.querySelector(' .p_DirectScene3Roll');
  const SkipButton = document.querySelector('.p_DirectSceneSkip');
  let LastLoopCardsCount = 0;
  const LastLoopCardsNum = Scene4Cards.length;
  const Time = 5000; // カードが飛んでくる時間(尺)

  // Scene1
  anime({
    targets: Scene1,
    duration: 1900,
    scale: [1, 1.05],
    easing: 'linear',
    complete: function (anim) {
      Scene1.classList.add('Hide');
      Scene1.classList.remove('Act');
      SkipButton.classList.add('Act');
    },
  });
  let tlBg = anime.timeline({
    targets: Bg,
  });
  tlBg
    .add({
      duration: 1500,
      easing: 'easeOutExpo',
      opacity: [0, 1],
    })
    .add({
      delay: 0,
      duration: 1800,
      easing: 'easeInExpo',
      update: function (anim) {
        Bg.style.filter = 'brightness(' + (3000 * anim.progress) / 100 + '%)';
      },
      complete: function (anim) {},
    });
  let tlLogo = anime.timeline({
    targets: Logo,
  });
  tlLogo
    .add({
      duration: 300,
      opacity: [0, 1],
      scale: [1.05, 1],
      easing: 'easeOutExpo',
      complete: function (anim) {},
    })
    .add({
      delay: 1200,
      duration: 1200,
      opacity: [1, 0],
      scale: [1, 1.1],
      easing: 'easeOutExpo',
      complete: function (anim) {},
    });

  const SceneOutTimer1 = setTimeout(() => {
    lastSceneOut();
  }, 2500);
  const SceneOutTimer2 = setTimeout(() => {
    loopCardMotion();
  }, 1950);
  const SceneOutTimer3 = setTimeout(() => {
    Scene3.classList.add('Act');
    // Scene2Out();
  }, 1900);
  // Ends Scene1

  // Scene2
  // let Scene2Anime = null;
  // const Scene2Out = () => {
  //   Scene2.classList.add('Act');
  //   Scene2Anime = anime({
  //     targets: Scene2,
  //     duration: 1400,
  //     opacity: [1, 0],
  //     scale: [0.2, 1.6],
  //     easing: 'easeOutExpo',
  //     update: function (anim) {
  //       Scene2.style.filter = 'blur(' + (10 * anim.progress) / 100 + 'px)';
  //     },
  //     complete: function (anim) {
  //       Scene2.classList.remove('Act');
  //     },
  //   });
  // };
  // const Scene2Stop = () => {
  //   if (Scene2Anime) {
  //     Scene2Anime.remove(Scene2);
  //   }
  // };
  // End Scene2

  // Scene3
  let Scenes3AnimeArr = [];
  const returnValue = (min = 1, max = 10, isMinus = false) => {
    let num = Math.floor(Math.random() * max) + min;
    if (isMinus) num *= Math.floor(Math.random() * 2) == 1 ? 1 : -1;
    return num;
  };
  const loopCardMotion = () => {
    for (let i = 0; i < Scene3Cards.length; i++) {
      let Scenes3Anime = anime({
        targets: Scene3Cards[i],
        translateX: [0, returnValue(150, 620, true)],
        translateY: [0, returnValue(100, 420, true)],
        scale: [0, 2],
        opacity: [1, 0],
        rotate: returnValue(40, 180, true),
        update: function (anim) {
          Scene3Cards[i].style.filter = 'blur(' + (20 * anim.progress) / 100 + 'px)';
        },
        duration: i === Scene3Cards.length - 1 ? 500 : returnValue(1000, 1500),
        loop: false,
        easing: 'easeInOutExpo',
        delay: (Time / Scene3Cards.length - 2) * i,
        complete:
          i === Scene3Cards.length - 1 &&
          function (anim) {
            // loopCardMotion();
          },
      });
      Scenes3AnimeArr.push(Scenes3Anime);
    }
  };

  const Scene3Stop = () => {
    for (let i = 0; i < Scenes3AnimeArr.length; i++) {
      Scenes3AnimeArr[i].remove(Scene3Cards[i]);
    }
  };

  let lastSceneOutTimer;
  let lastSceneOutTimer2;
  let lastSceneOutAnime;
  const lastSceneOut = () => {
    lastSceneOutTimer = setTimeout(() => {
      lastSceneOutAnime = anime({
        targets: Scene3Roll,
        duration: 2000,
        delay: 1500,
        opacity: [1, 0],
        easing: 'easeOutExpo',
        complete: function (anim) {},
      });
    }, Time * 0.85);

    lastSceneOutTimer2 = setTimeout(() => {
      Scene4.classList.add('Act');
      lastLoopCard(Scene4Cards[LastLoopCardsCount]);
    }, Time + 700);
  };
  // End Scene3

  // Scene4
  let lastLoopAnime;
  let lastLoopWipeAnime;
  const lastLoopCard = (Card) => {
    Card.classList.add('Act');
    lastLoopAnime = anime({
      targets: Card,
      duration: 800,
      opacity: [1, 1],
      scale: [0.4, 1],
      easing: 'cubicBezier(0.000, 0.885, 0.150, 1.115)',
      update: function (anim) {
        Card.style.filter = 'blur(' + (0 * anim.progress) / 100 + 'px)';
      },
      complete: function (anim) {
        lastLoopAnime = null;
        lastLoopCardWipe(Card);
      },
    });
  };

  const lastLoopCardWipe = (Card) => {
    lastLoopWipeAnime = anime({
      targets: Card,
      duration: 800,
      opacity: [1, 0],
      scale: [1, 1.5],
      easing: 'cubicBezier(0.000, 0.885, 0.150, 1.115)',
      update: function (anim) {
        Card.style.filter = 'blur(' + (0 * anim.progress) / 100 + 'px)';
      },
      complete: function (anim) {
        LastLoopCardsCount++;
        if (LastLoopCardsCount < LastLoopCardsNum) {
          lastLoopCard(Scene4Cards[LastLoopCardsCount]);
          lastLoopWipeAnime = null;
        } else {
          lastLoopWipeAnime = null;
          goToLastEvent();
        }
      },
    });
  };

  // 最後の画面が捌けるイベント
  const goToLastEvent = () => {
    anime({
      targets: Scene,
      duration: 2000,
      easing: 'easeOutExpo',
      opacity: [1, 0],
      complete: function (anim) {
        doneEvent();
      },
    });
  };
  const doneEvent = () => {
    location.replace(next_url);
  };
  // End Scene4

  // Reset
  SkipButton.addEventListener('click', () => {
    resetEvent();
  });
  const resetEvent = () => {
    clearTimeout(SceneOutTimer1);
    // clearTimeout(SceneOutTimer2);
    clearTimeout(SceneOutTimer3);
    // Scene2Stop();
    Scene3Stop();
    if (lastSceneOutTimer) clearTimeout(lastSceneOutTimer);
    if (lastSceneOutTimer2) clearTimeout(lastSceneOutTimer2);
    if (lastSceneOutAnime) lastSceneOutAnime.remove(Scene3);
    if (lastLoopAnime) lastLoopAnime.remove(Scene4Cards[LastLoopCardsCount]);
    if (lastLoopWipeAnime) lastLoopWipeAnime.remove(Scene4Cards[LastLoopCardsCount]);
    goToLastEvent();
    SkipButton.remove();
  };
  // End Reset
}
